/* ccAuthConnect
 *   Esta função serve para embutir o processo de renovação de token.
 * Ela deve ser chamada pelo Helper de autenticação, para que lá sejam
 * exportadas como um 'fetcher'
 *   Existe uma função muito similar a esta, mas que serve para a realização de
 * múltiplos fetches simultâneos. O nomeei de MultipleFetch. A principal vantagem
 * em utiliza-lo é, caso o token tenha que ser renovado, não serem feitas várias
 * chamadas para renovação. Ou seja, ao perceber a necessidade de renovação, o 
 * processo ocorre uma vez, e se a renovação ocorrer com sucesso, os multiples
 * fetches são executados já com o nosso token recém-renovado.
 * 
 *   Pensei nas seguintes alternativas para esse código (um pouco confuso):
 * 1. Embutir tudo relacionado a esta biblioteca de autenticação em uma classe.
 * Com isso, a função contida aqui passaria a ser um método.
 * 2. Apenas renomear esse arquivo...
 *
 */
import { getToken, setToken, isValid, isExpired } from "./utils";
import ccFetch from "../ccFetch";
// import { AuthenticationError } from "@contcontrol/cc-errors";

class AuthenticationError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.alias = "Erro de autenticação";
  }
}


export default function(params) {
  // params are injected on lib import
  const { authDomain, authRenewUri, notAuthenticated, tokenChanged } = params;
  let renewFullUrl = `${authDomain}${authRenewUri}`
  return function(apiCaller) {
    // apiCaller is the function that will be the interface between front and back-end
    // (fetch or axios, for example...)
    return function() {
    // return new Promise((resolve,reject) => {
      let tk = getToken();
      if (!isValid(tk)) {
        console.error("Token inválido ou inexistente.");
        notAuthenticated()
        return Promise.reject(new AuthenticationError("Não autenticado"));
      } else if (isExpired(tk)) {
        // console.log("Token expirado, tentando renovar...");
        return ccFetch(renewFullUrl, {
          method: "post",
          headers: {
            "Content-Type": "application/json"
          }
        })
          .then(r => r.json())
          .then(r => setToken(r.tk))
          .then(tokenChanged)
          .then(r => apiCaller.apply(this, arguments))
          .then(r => Promise.resolve(r))
          .catch(err => {
            console.error("Falha ao renovar token...", err);
            // notAuthenticated();
            return Promise.reject(new AuthenticationError("Token não foi renovado com sucesso, favor re-autenticar"));
          });
      } else {
        // console.log("Token válido e ativo, prosseguindo...");
        return Promise.resolve(apiCaller.apply(this, arguments));
      }
    };
    // })
  };
}
